import React from 'react';
import { Leaf } from 'lucide-react';
export function Footer() {
  return <footer className="bg-forest text-cream py-16 border-t border-white/10" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="flex flex-col items-center text-center space-y-8" data-id="element-122">
          <div className="flex items-center gap-2" data-id="element-123">
            <div className="bg-white/10 p-2 rounded-full" data-id="element-124">
              <Leaf className="h-6 w-6 text-sage-light" data-id="element-125" />
            </div>
            <span className="font-serif text-xl font-bold tracking-tight" data-id="element-126">
              PequeSalud <span className="text-terracotta-light" data-id="element-127">Natural</span>
            </span>
          </div>

          <p className="text-cream/60 max-w-md text-sm leading-relaxed" data-id="element-128">
            Guía de apoyo natural para padres conscientes.
            <br data-id="element-129" />
            Claridad y calma cuando más lo necesitas.
          </p>

          <div className="w-full h-px bg-white/10 max-w-xs mx-auto" data-id="element-130"></div>

          <div className="text-xs text-cream/40 space-y-4 max-w-2xl" data-id="element-131">
            <p data-id="element-132">
              © {new Date().getFullYear()} PequeSalud Natural. Todos los
              derechos reservados.
            </p>
            <p className="italic" data-id="element-133">
              Descargo de responsabilidad: La información contenida en esta guía
              tiene fines educativos y de apoyo. No sustituye el consejo,
              diagnóstico o tratamiento médico profesional. Siempre busque el
              consejo de su médico u otro proveedor de salud calificado ante
              cualquier duda sobre una condición médica.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}